export default {
    nav: {
        ReserveGift: '预约领豪礼',
        FollowFbRaffle: '关注FB抽奖',
        CharacterIntroduction: '角色介绍',
        Gameplay: '玩法介绍',
        AttentionFB: '关注官方FB',
        DownloadGift: '下载领豪礼',
    },
    first: {
        ShopReserve: '商店预约送',
        ShopDown: '商店下载送',
        PhoneReserve: '手机预约送橙将',
        PhoneDown: '手机下载送橙将',
        Reserve: '立即预约',
        Down: '立即下载',
        PraiseAward: '按赞官方FB领奖',
        PraiseGift: '按赞官方FB送豪礼',

    },
    reach: {
        NumberOfPeople: '预约达成人数',
        Achieved: '达成',
        NotAchieved: '未达成',
        Unit: '万人',
        ServiceReward: '预约目标达成后，发送全服奖励',
        SlimageAwards: '前往瓜分大奖',
    },
    other: {
        GameIntroduction: '游戏介绍',
        CommunityInformation: '社群资讯',
        MoreGift: '按赞官方FB粉丝团送更多豪礼',
        PleaseEnter: '请输入正确手机号码',
        Expect: '敬请期待',
        restrict: "请勿频繁注册",
    },
    side: {
        ReservationNow: '立即预约送2024抽',
        FollowFbRaffle: '关注官方FB抽奖',
        Down: '立即下载送2024抽'
    },
    popups: {
        LimitedTime: '限时30s内预约送2024抽！',
        AddReserve: '前往商店预约追加赠送2024抽',
        Get: '恭喜您获得手机预约奖励',
        Code: '礼包码：',
        Congratulations: '恭喜您',
        CompleteStoreAppointment: '完成商店预约',
        FbCommunity: '按赞官方FB社群',
        GetGoodGift: '加码领好礼',
        Over: '预约活动已结束',
        PhoneReserveSuccess: '您已成功手机预约',
        AddDown: '前往商店下载追加赠送2024抽'
    },

}
